<template>
  <div>
    <div class="container-xxl bg-fixo" id="titulo">
      <titulo-grande texto="Quem Somos" posicao="left" class="py-5" />
    </div>
    <PainelBase theme="dark" :bgAtivo="true" class="bg-fixo" id="quemsomos">
      <div class="col-sm-12">
        <p class="paragrafo">
          Seja bem vindo! Somos um movimento com o objetivo educar politicamente as pessoas. Não defendemos nenhum
          partido específico e nem políticos. Defendemos a importância do voto consciente para que o Brasil realmente
          possa viver uma democracia.
        </p>
      </div>
    </PainelBase>
    <PainelBase theme="dark" tipoTitulo="duplo" titulo="Nossa Missão" :bgAtivo="true" class="bg-fixo" id="missao">
      <div class="col-sm-12">
        <p class="paragrafo">
          A missão do movimento Saia do Sofá é promover a educação política no Brasil, capacitando eleitores através de
          cursos e palestras. Acreditamos que a formação de cidadãos informados é essencial para a construção de uma
          sociedade mais justa e democrática, onde cada voto é um reflexo consciente das escolhas e valores da
          população.
        </p>
      </div>
    </PainelBase>
    <PainelBase theme="light" tipoTitulo="duplo" titulo="Nossa Visão" :bgAtivo="true" class="bg-fixo" id="visao">
      <div class="col-sm-12">
        <p class="paragrafo">
          Imaginamos um Brasil onde todos os cidadãos são capazes e informados para exercer seu direito de voto. Nosso
          propósito é contribuir para um futuro democrático, onde eleitores preparados e conscientes participam
          ativamente do processo político, resultando em uma nação mais justa, equitativa e engajada.
        </p>
      </div>
    </PainelBase>
  </div>
</template>

<script>
import TituloGrande from "@/components/TituloGrande.vue";
import { efeito, meta_default, muda_titulo } from '@/assets/js/functions'
import TituloDuplo from "@/components/TituloDuplo.vue";
import PainelBase from "@/components/PainelBase.vue";

export default {
  components: { TituloGrande, TituloDuplo, PainelBase },
  name: "QuemSomos",
  // metaInfo: {
  //   title: 'Quem Somos',
  //   meta: meta_default('Quem Somos')
  // },
  created() {
    muda_titulo({
      title: 'Quem Somos',
      meta: meta_default('Quem Somos')
    })
  },
};
</script>

<style scoped>
#titulo::before {
  background-image: url('/public/img/quemsomos.jpg');
}

#missao {
  background-color: var(--cor-base-fundo-transp)
}

#missao::before {
  background-image: url('/public/img/missao.jpg');
}

#visao {
  background-color: var(--cor-base-branco-transp)
}

#visao::before {
  background-image: url('/public/img/visao.jpg');
}
</style>